module.exports = __webpack_public_path__ + "static/scale-model-of-lehigh-valley-heritage-museum-in-allentown-pennsylvania-93f9893edb55a7406ba8514799e4e70b.png";